var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, HostListener } from '@angular/core';
import { StorageKeys } from '../../enums/storage-keys';
import { CookieReader } from '../../storage/cookie-reader';
import { SessionStorageUpdater } from '../../storage/session-storage.updater';
import { CookieUpdater } from '../../storage/cookie-updater';
var AppComponent = /** @class */ (function () {
    function AppComponent(cookieReader, cookieUpdater, sessionStorageUpdater) {
        this.cookieReader = cookieReader;
        this.cookieUpdater = cookieUpdater;
        this.sessionStorageUpdater = sessionStorageUpdater;
        var basketCookie = this.cookieReader.getCookie(StorageKeys.BasketCookie);
        if (basketCookie) {
            this.sessionStorageUpdater.setItem(StorageKeys.Basket, basketCookie);
        }
    }
    AppComponent.prototype.clearState = function () {
        this.cookieUpdater.deleteCookie(StorageKeys.StandardsUser);
        this.cookieUpdater.deleteCookie(StorageKeys.WorkloadManagerUser);
    };
    __decorate([
        HostListener('window:beforeunload'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], AppComponent.prototype, "clearState", null);
    AppComponent = __decorate([
        Component({
            selector: 'app-standards',
            template: require('./app.component.html')
        }),
        __metadata("design:paramtypes", [CookieReader,
            CookieUpdater,
            SessionStorageUpdater])
    ], AppComponent);
    return AppComponent;
}());
export { AppComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXBwLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImFwcC5jb21wb25lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxZQUFZLEVBQUcsTUFBTSxlQUFlLENBQUM7QUFDekQsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLDBCQUEwQixDQUFDO0FBQ3ZELE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSw2QkFBNkIsQ0FBQztBQUMzRCxPQUFPLEVBQUUscUJBQXFCLEVBQUUsTUFBTSx1Q0FBdUMsQ0FBQztBQUM5RSxPQUFPLEVBQUUsYUFBYSxFQUFFLE1BQU0sOEJBQThCLENBQUM7QUFNN0Q7SUFDSSxzQkFBb0MsWUFBMEIsRUFDekMsYUFBNEIsRUFDNUIscUJBQTRDO1FBRjdCLGlCQUFZLEdBQVosWUFBWSxDQUFjO1FBQ3pDLGtCQUFhLEdBQWIsYUFBYSxDQUFlO1FBQzVCLDBCQUFxQixHQUFyQixxQkFBcUIsQ0FBdUI7UUFDN0QsSUFBSSxZQUFZLEdBQUcsSUFBSSxDQUFDLFlBQVksQ0FBQyxTQUFTLENBQUMsV0FBVyxDQUFDLFlBQVksQ0FBQyxDQUFDO1FBQ3pFLElBQUksWUFBWSxFQUFFO1lBQ2QsSUFBSSxDQUFDLHFCQUFxQixDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQUMsTUFBTSxFQUFFLFlBQVksQ0FBQyxDQUFDO1NBQ3hFO0lBQ0wsQ0FBQztJQUdPLGlDQUFVLEdBQWxCO1FBQ0ksSUFBSSxDQUFDLGFBQWEsQ0FBQyxZQUFZLENBQUMsV0FBVyxDQUFDLGFBQWEsQ0FBQyxDQUFDO1FBQzNELElBQUksQ0FBQyxhQUFhLENBQUMsWUFBWSxDQUFDLFdBQVcsQ0FBQyxtQkFBbUIsQ0FBQyxDQUFDO0lBQ3JFLENBQUM7SUFIRDtRQURDLFlBQVksQ0FBQyxxQkFBcUIsQ0FBQzs7OztrREFJbkM7SUFkUSxZQUFZO1FBSnhCLFNBQVMsQ0FBQztZQUNQLFFBQVEsRUFBRSxlQUFlO1lBQ3pCLFFBQVEsRUFBRSxPQUFPLENBQUMsc0JBQXNCLENBQUM7U0FDNUMsQ0FBQzt5Q0FFb0QsWUFBWTtZQUMxQixhQUFhO1lBQ0wscUJBQXFCO09BSHhELFlBQVksQ0FleEI7SUFBRCxtQkFBQztDQUFBLEFBZkQsSUFlQztTQWZZLFlBQVkifQ==